"use strict";
exports.__esModule = true;
exports.FLEX_HISTORY_CREDIT_MODAL = exports.FLEX_HISTORY_RENT_MODAL = void 0;
exports.FLEX_HISTORY_RENT_MODAL = {
    HEADER: 'Reporting rent payments',
    CTA: 'Close',
    MODAL_BODY: 'Did you know that your biggest monthly expense is not automatically factored into your credit?\n\nThe good news is that every time you pay rent with Flex, we can send a report to the credit bureaus indicating that you made an on-time rent payment\n\nFor people without much credit history, this is a great way to build a strong credit profile. And even if you have good history, reporting rent payments can improve your credit score.\n\nThe best part is that Flex will only report on-time payments, so rent reporting will never hurt your credit score.'
};
exports.FLEX_HISTORY_CREDIT_MODAL = {
    HEADER: 'Reporting credit line usage',
    CTA: 'Close',
    MODAL_BODY_ONE: 'Remember that credit line we mentioned when you joined Flex? That’s one of the key ingredients in helping you boost your credit.\n\nCredit lines are a major factor in determining your credit score. In fact, your credit line usage accounts for up to 80% of your score.\n\nWhen you pay rent with Flex and settle your balance each month, we report that you:',
    LINE_ITEMS: [
        'Paid Flex on time',
        'Used $0 of your credit line (this is a good thing!)',
        'Kept your credit in line for another month',
    ],
    MODAL_BODY_TWO: 'All of these aspects of our reports reflect positively on your profile and can lead to higher credit scores!'
};
